<template>
  <base-account>
    <section class="section hero-section bg-ico-hero" id="home">
      <div class="bg-overlay bg-primary"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden">
              <div class="bg-soft-primary">
                <div class="row">
                  <div class="col-7">
                    <div class="text-primary p-4">
                      <h5 class="text-primary">Recuperação de senha</h5>
                      <p>Informe o token e sua nova senha</p>
                    </div>
                  </div>
                  <div class="col-5 align-self-end">
                    <img src="@/assets/images/profile-img.png" alt class="img-fluid"/>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div role="alert" v-show="resposta.status" aria-live="polite" aria-atomic="true"
                     class="alert alert-success mt-2">
                  <i class="mdi mdi-check-all mr-2"></i> {{ resposta.mensagem }}
                </div>
                <div role="alert" v-show="resposta.status === false" aria-live="polite" aria-atomic="true"
                     class="alert alert-danger mt-2">
                  <i class="mdi mdi-block-helper mr-2"></i> {{ resposta.mensagem }}
                </div>
                <Loader :loading="httpSend">
                  <b-form v-show="resposta.status !== true" class="p-2" @submit.prevent="tryToRegisterIn">

                    <b-form-group
                        id="token-label"
                        label="Token"
                        label-for="token">
                      <input
                          id="token"
                          v-model="user.ahr_token"
                          type="text"
                          autocomplete="off"
                          class="form-control text-uppercase"
                          v-mask="'NNNN-NNNN'"
                          :class="{'is-invalid': submitted && $v.user.ahr_token.$error,}">
                      <div class="text-muted">
                        Informe o token recebido no e-mail
                      </div>
                    </b-form-group>

                    <b-form-group
                        id="password-group"
                        label="Nova Senha"
                        label-for="password">
                      <input
                          id="password"
                          v-model="user.aut_senha"
                          type="password"
                          autocomplete="new-password"
                          class="form-control"
                          placeholder="Utilize letras, números e caracteres especiais"
                          :class="{
                    'is-invalid': submitted && $v.user.aut_senha.$error,
                  }">
                      <div v-show="user.aut_senha" class="mt-2 progress">
                        <div role="progressbar" v-show="passwordStrength.score <= 5" aria-valuemin="0"
                             aria-valuemax="30"
                             aria-valuenow="27" class="progress-bar bg-danger" style="width: 30%;">Péssima
                        </div>
                        <div role="progressbar" v-show="passwordStrength.score > 2" aria-valuemin="0" aria-valuemax="35"
                             aria-valuenow="35" class="progress-bar bg-warning" style="width: 35%;">Fraca
                        </div>
                        <div role="progressbar" v-show="passwordStrength.score > 3" aria-valuemin="0" aria-valuemax="35"
                             aria-valuenow="7" class="progress-bar bg-success" style="width: 35%;">Boa
                        </div>
                      </div>
                      <div v-if="submitted && !$v.user.aut_senha.required" class="invalid-feedback">
                        Informe uma senha.
                      </div>
                    </b-form-group>

                    <b-form-group
                        id="password-reply-group"
                        label="Repita sua nova senha"
                        label-for="password">
                      <input
                          id="password-reply"
                          v-model="user.aut_senha_reply"
                          type="password"
                          class="form-control"
                          placeholder=""
                          :class="{'is-invalid': submitted && $v.user.aut_senha_reply.$error,}">
                      <div v-show="senhaDiferentes" class="text-danger">
                        As senhas não coincidem
                      </div>
                    </b-form-group>

                    <div class="mt-4">
                      <b-button type="submit" :disabled="passwordStrength.score < 3 || $v.user.$invalid || senhaDiferentes"
                                variant="primary"
                                class="btn-block">Recuperar senha
                      </b-button>
                    </div>

                  </b-form>
                </Loader>
              </div>
            </div>
            <div class="mt-5 text-center text-white">
              <p>
                Já possui conta ?
                <router-link
                    tag="a"
                    to="/"
                    class="font-weight-medium text-danger">Login
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </base-account>
</template>
<script>
const zxcvbn = require('zxcvbn');
import appConfig from "@/dados/app.config.json";
import Loader from "@/components/widgets/loader"
import {setRecover} from "@/api/login/auth"
import {required} from "vuelidate/lib/validators";
import BaseAccount from "@/router/layouts/base-account"

export default {
  page: {
    title: "Register",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    BaseAccount,
    Loader,
  },
  data() {
    return {
      entidade: {},
      user: {
        ahr_hash: "",
        ahr_token: "",
        aut_senha: "",
        aut_senha_reply: "",
      },
      resposta: {
        status: null,
        mensagem: ''
      },
      httpSend: false,
      submitted: false,
      cpfInvalido: false,
    };
  },
  validations: {
    user: {
      ahr_token: {
        required,
      },
      aut_senha: {
        required,
      },
      aut_senha_reply: {
        required,
      },
    },
  },
  computed: {
    passwordStrength() {
      return zxcvbn(this.user.aut_senha);
    },
    senhaDiferentes() {
      return (this.user.aut_senha !== this.user.aut_senha_reply);
    }
  },
  methods: {
    tryToRegisterIn() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.user.ahr_hash = this.$route.params.ahr_hash;
      this.httpSend = true;
      setRecover(this.$route.params.ahr_hash, this.user).then(response => {
        this.resposta = response
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false
      })
    },
  },
};
</script>


<style lang="scss" module></style>
